module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"countdown":"CHECKOUT BEFORE REWARD EXPIRES IN"},"ar":{"countdown":"أكمل عملية الشراء قبل انتهاء العرض خلال"}}')
  delete Component.options._Ctor
}
